import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  experiences: [],
  hasBackButton: false,
  isMobile: false,
  isOfferingOpen: false,
  isOptionsOpen: false,
  selectedExperience: null,
  selectedDate: null,
  selectedSeats: null,
  selectedTime: null,
  venueId: null,
  venueName: null,
};

const tockExperienceSlice = createSlice({
  name: 'tockExperience',
  initialState,
  reducers: {
    openTockExperienceOptions: (state, action) => {
      const {
        experiences = [],
        isMobile = false,
        selectedDate = null,
        selectedSeats = null,
        selectedTime = null,
        venueId = null,
        venueName = null,
      } = action.payload || {};
      state.isOptionsOpen = true;
      state.experiences = experiences;
      state.isMobile = isMobile;
      state.selectedDate = selectedDate;
      state.selectedSeats = selectedSeats;
      state.selectedTime = selectedTime;
      state.venueId = venueId;
      state.venueName = venueName;
    },
    openTockExperienceOffering: (state, action) => {
      const {
        hasBackButton = false,
        isMobile = false,
        selectedExperience = null,
        selectedDate = null,
        selectedSeats = null,
        venueId = null,
        venueName = null,
      } = action.payload || {};
      state.hasBackButton = hasBackButton;
      state.selectedExperience = selectedExperience;
      state.selectedDate = selectedDate;
      state.selectedSeats = selectedSeats;
      state.isMobile = isMobile;
      state.venueId = venueId;
      state.venueName = venueName;
      state.isOptionsOpen = false;
      state.isOfferingOpen = true;
    },
    goBackToOptions: (state) => {
      state.isOfferingOpen = false;
      state.isOptionsOpen = true;
    },
    closeTockExperienceModal: () => initialState,
  },
});

export const {
  openTockExperienceOptions,
  openTockExperienceOffering,
  goBackToOptions,
  closeTockExperienceModal,
} = tockExperienceSlice.actions;

export default tockExperienceSlice.reducer;
